import React from 'react'
import { SkeletonBar } from './DashboardSkeletonBar'
import { schoolSurface } from './schoolEquipmentChrome'

const HikvisionDeviceDashboardSkeleton = () => (
  <div className="flex flex-col gap-6" aria-busy="true" aria-label="Загрузка устройства">
    <SkeletonBar className="h-3 w-28 rounded-full" />

    <header className="-mt-3 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        <SkeletonBar className="mb-2 h-2.5 w-28" />
        <div className="flex flex-wrap items-center gap-3">
          <SkeletonBar className="h-9 w-56 max-w-full md:h-10 md:w-72" />
          <div className="flex items-center gap-1.5">
            <SkeletonBar className="h-2 w-2 rounded-full" />
            <SkeletonBar className="h-3.5 w-24" />
          </div>
        </div>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <SkeletonBar className="h-3.5 w-36" />
          <SkeletonBar className="h-3 w-2" />
          <SkeletonBar className="h-3.5 w-28" />
          <SkeletonBar className="h-3 w-2" />
          <SkeletonBar className="h-3.5 w-16" />
          <SkeletonBar className="ml-2 h-3.5 w-24" />
        </div>
      </div>
      <SkeletonBar className="h-10 w-28 rounded-xl" />
    </header>

    <section className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className={`rounded-2xl px-4 py-3 ${schoolSurface.tile}`}>
          <SkeletonBar delay={`${index * 70}ms`} className="h-2.5 w-14" />
          <SkeletonBar delay={`${index * 70}ms`} className="mt-2 h-7 w-12" />
        </div>
      ))}
    </section>

    <section className="grid grid-cols-1 gap-4 xl:grid-cols-12">
      <div className="xl:col-span-4">
        <div className={`w-full rounded-2xl p-3 ${schoolSurface.section}`}>
          <SkeletonBar className="mb-2 h-5 w-24" />
          <div className={`rounded-lg px-2.5 py-1.5 ${schoolSurface.card}`}>
            <div className="flex items-center gap-2">
              <SkeletonBar className="h-7 w-10" />
              <SkeletonBar className="h-3.5 w-14" />
              <SkeletonBar className="ml-auto h-5 w-16 rounded-md" />
              <SkeletonBar className="h-5 w-16 rounded-md" />
            </div>
          </div>
        </div>
      </div>
      <div className="xl:col-span-8">
        <div className={`rounded-3xl p-6 ${schoolSurface.section}`}>
          <SkeletonBar className="mb-4 h-6 w-24" />
          <SkeletonBar className="aspect-video w-full rounded-2xl" />
        </div>
      </div>
    </section>

    <section className={`rounded-3xl p-6 ${schoolSurface.section}`}>
      <header className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap items-center gap-3">
          <SkeletonBar className="h-6 w-36" />
          <div className="inline-flex rounded-xl bg-surface-2 p-1">
            <SkeletonBar className="h-7 w-24 rounded-lg" />
            <SkeletonBar className="ml-1 h-7 w-20 rounded-lg" />
          </div>
        </div>
        <div className="inline-flex rounded-xl bg-surface-2 p-1">
          {['w-12', 'w-16', 'w-16', 'w-14', 'w-16'].map((width, index) => (
            <SkeletonBar key={index} delay={`${index * 50}ms`} className={`h-7 ${width} rounded-lg`} />
          ))}
        </div>
      </header>
      <div className={`rounded-3xl p-5 ${schoolSurface.card}`}>
        <SkeletonBar className="mb-3 h-3 w-40" />
        <SkeletonBar className="mb-5 h-2.5 w-full rounded-full" />
        <SkeletonBar className="h-80 w-full rounded-2xl" />
      </div>
    </section>
  </div>
)

export default HikvisionDeviceDashboardSkeleton
